var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0001 0L23.0349 0.542472C28.8665 3.54891 34.1753 5.23176 40.3334 6.06792L40.3221 11.1166L40.2973 13.3443C40.0547 28.6113 38.1805 37.0876 23.7028 43.3022L22.0001 44L21.3531 43.7424C4.66116 36.9816 3.72266 27.5834 3.66989 9.41055L3.66675 6.06792C9.82482 5.23176 15.1336 3.54891 20.9653 0.542472L22.0001 0Z",
    fill: "#B8963A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 2L22.9596 2.49316C28.3671 5.22628 33.2898 6.75615 39 7.51629L38.9895 12.106L38.9665 14.1311C38.7416 28.0102 37.0036 35.716 23.5789 41.3657L22 42L21.4001 41.7658C5.92209 35.6197 5.05184 27.0758 5.00291 10.555L5 7.51629C10.7102 6.75615 15.6329 5.22628 21.0404 2.49316L22 2Z",
    fill: "#081C38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 4L22.8467 4.44384C27.618 6.90365 31.9616 8.28053 37 8.96466L36.9907 13.0954L36.9705 14.918C36.772 27.4092 35.2385 34.3444 23.3931 39.4291L22 40L21.4706 39.7892C7.81361 34.2577 7.04575 26.5682 7.00257 11.6995L7 8.96466C12.0384 8.28053 16.382 6.90365 21.1533 4.44384L22 4Z",
    fill: "#B8963A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.511L20 27L30 16",
    stroke: "#081C38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldIcon);
export default __webpack_public_path__ + "static/media/ShieldIcon.35b1d10a3beabcbe1785a8cfe2cfdcb5.svg";
export { ForwardRef as ReactComponent };